const compact = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
});
const grouped = new Intl.NumberFormat('en-US');

/**
 * "412.6K" from `compactFrom` up, "8,930" below. Figma compacts from 10,000
 * on the metric cards and followers, but from 1,000 for the table's gains
 * ("+4.1K").
 */
export function formatCount(value: number, compactFrom = 10_000): string {
  return Math.abs(value) >= compactFrom
    ? compact.format(value)
    : grouped.format(Math.round(value));
}

/** "+241.8K", "−5" */
export function formatGain(value: number, compactFrom?: number): string {
  return `${value < 0 ? '−' : '+'}${formatCount(Math.abs(value), compactFrom)}`;
}

/** "6.1%" */
export function formatPercent(value: number): string {
  return `${value.toFixed(1)}%`;
}

/** "26 Aug" */
export function formatDay(date: Date): string {
  return `${date.getDate()} ${date.toLocaleString('en-US', { month: 'short' })}`;
}

/** "Thu 24, 09:02" */
export function formatWhen(date: Date): string {
  const weekday = date.toLocaleString('en-US', { weekday: 'short' });
  const time = date.toLocaleString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return `${weekday} ${date.getDate()}, ${time}`;
}

/** "Just now", "40 min ago", "2 h ago", "3 d ago" */
export function formatAgo(date: Date, now: Date): string {
  const minutes = Math.round((now.getTime() - date.getTime()) / 60_000);
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} h ago`;
  return `${Math.round(hours / 24)} d ago`;
}
